import { LEGAL_DOCUMENT_BODY_CLASS } from "./legalDocumentBodyClass";
import { LegalDocumentRevisionFooter } from "./LegalDocumentRevisionFooter";

export function TermsContent() {
  return (
    <div className={LEGAL_DOCUMENT_BODY_CLASS}>
      <h1>Пользовательское соглашение</h1>

      <p>
        Настоящее Пользовательское соглашение регулирует отношения между
        Индивидуальным предпринимателем Ивановым Дмитрием Вячеславовичем (ОГРНИП
        326310000006739, ИНН 312730999383), далее — «Исполнитель», и Пользователем
        сервиса Mom Recipes.
      </p>

      <h2>1. Общие положения</h2>
      <p>
        Mom Recipes — это сервис с использованием искусственного интеллекта для
        генерации рецептов для детей и семьи.
      </p>

      <h2>2. Регистрация и использование</h2>
      <p>
        Пользователь может использовать вымышленные данные профилей детей и семьи.
        Ответственность за корректность, актуальность и уместность вводимых данных
        лежит на Пользователе.
      </p>

      <h2>3. Подписка</h2>
      <p>
        Бесплатная версия сервиса ограничена по функциональности. Полный функционал
        предоставляется по подписке Premium (оплата за месяц или за год) либо в
        рамках пробного периода (trial), если он доступен в интерфейсе приложения
        (в текущей версии — до 3 дней при условиях, указанных в приложении).
      </p>
      <p>
        Доступ к платным функциям предоставляется на срок, соответствующий
        оплаченному периоду или условиям trial. В текущей версии приложения оплата
        оформляется как разовое списание за выбранный период через платёжного
        провайдера; автоматическое продление подписки без нового платежа в
        приложении не подключается.
      </p>

      <h2>4. Ограничение ответственности</h2>
      <p>
        Сервис использует технологии искусственного интеллекта. Сводимая в сервисе
        информация (включая рецепты и подсказки) может содержать неточности,
        ошибки и неполноту.
      </p>
      <p>
        Рецепты и рекомендации носят исключительно информационный и
        рекомендательный характер. Они не являются медицинскими,
        диетологическими или иными профессиональными назначениями и не заменяют
        консультацию врача или специалиста.
      </p>
      <p>
        Пользователь самостоятельно отвечает за проверку ингредиентов, аллергенов,
        переносимости продуктов, соответствия блюд возрасту ребёнка и состоянию
        здоровья членов семьи, а также за решение о приготовлении и употреблении
        пищи.
      </p>
      <p>
        Исполнитель не несёт ответственности за аллергические реакции,
        нежелательные последствия, вред здоровью, упущенную выгоду, косвенные
        убытки и иные последствия использования информации сервиса. Пользователь
        обязан самостоятельно и критически проверять важную для безопасности и
        здоровья информацию перед её применением на практике.
      </p>
      <p>
        Сервис предоставляется по принципу «как есть» (as is). Исполнитель не
        гарантирует, что сервис в каждом случае полностью совпадёт с ожиданиями
        Пользователя; не гарантируется бесперебойная работа сервиса, отсутствие
        сбоев, ошибок или задержек; также не гарантируется, что сервис будет
        пригоден для конкретных целей, задач или результатов, которые Пользователь
        для себя определяет. Указанное дополняет положения о работе искусственного
        интеллекта (раздел 5) и не ограничивает их.
      </p>

      <h2>5. Использование искусственного интеллекта</h2>
      <p>
        Сервис применяет искусственный интеллект для генерации и подбора контента.
        Такой контент может быть неточным, неполным или неактуальным. Исполнитель
        не гарантирует абсолютную достоверность, полноту и применимость
        сгенерированного контента в каждой конкретной ситуации.
      </p>

      <h2>6. Возраст и законный представитель</h2>
      <p>
        Сервис предназначен для использования совершеннолетними пользователями.
        Подключаясь к сервису и создавая профили детей, Пользователь подтверждает,
        что действует как законный представитель ребёнка (родитель или иное лицо,
        уполномоченное законом) при вводе данных и использовании сервиса для
        подбора рецептов и информации о питании ребёнка.
      </p>

      <h2>7. Ограничение доступа</h2>
      <p>
        Исполнитель вправе ограничить или прекратить доступ Пользователя к сервису
        при нарушении настоящего соглашения, злоупотреблении функциональностью
        сервиса или использовании сервиса способом, противоречащим закону или
        правам третьих лиц.
      </p>

      <h2>8. Права на контент</h2>
      <p>
        Материалы сервиса (тексты, оформление, подборки, программный код интерфейса
        и т.п.) являются объектами интеллектуальной собственности Исполнителя либо
        используются на законных основаниях. Пользователь может использовать
        материалы сервиса только для личных некоммерческих целей в рамках
        предусмотренного функционала.
      </p>
      <p>
        Запрещается копирование, распространение, перепродажа или массовое
        воспроизведение материалов сервиса без согласия Исполнителя, если иное не
        следует из императивных норм закона.
      </p>

      <h2>9. Изменение сервиса</h2>
      <p>
        Исполнитель вправе изменять, обновлять, ограничивать, временно
        приостанавливать или прекращать отдельные функции сервиса, а также менять
        состав возможностей, интерфейс, тарифные планы, условия и длительность
        пробного периода (trial), лимиты использования и правила работы сервиса.
        Исполнитель не обязуется бессрочно сохранять тот же набор функций или
        условий, что действовали на любой прошлый момент.
      </p>
      <p>
        Такие изменения могут вноситься без направления Пользователю заранее
        индивидуального уведомления, если иное не вытекает из императивных норм
        применимого закона. Актуальные параметры тарифов, trial и лимитов
        отображаются в интерфейсе приложения; существенные изменения в текстах
        соглашения и связанных документов — на соответствующих страницах сервиса.
      </p>

      <h2>10. Изменение документов</h2>
      <p>
        Исполнитель вправе вносить изменения в настоящее Пользовательское
        соглашение, Политику конфиденциальности и Условия подписки. Актуальная
        редакция размещается в приложении на соответствующих экранах и страницах.
      </p>
      <p>
        Продолжение использования сервиса после публикации новой редакции
        указанных документов означает, что Пользователь принимает обновлённые
        условия, если иное не установлено законом. Версия согласия, зафиксированная
        при регистрации в учётных данных Пользователя, сохраняется для учёта
        момента первого принятия условий; дальнейшее пользование сервисом
        регулируется актуальной редакцией документов, размещённой в приложении.
      </p>

      <h2>11. Применимое право</h2>
      <p>
        <strong>Настоящее соглашение регулируется законодательством Российской Федерации.</strong>
      </p>

      <h2>12. Контакты</h2>
      <p>
        Исполнитель: ИП Иванов Дмитрий Вячеславович
        <br />
        Юр. адрес: 309181, Россия, Белгородская обл., г. Губкин, ул. Кирова, д. 67А,
        кв. 73
        <br />
        Email:{" "}
        <a href="mailto:aiapps.probusiness@gmail.com">aiapps.probusiness@gmail.com</a>
      </p>
      <LegalDocumentRevisionFooter />
    </div>
  );
}
